"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUnavDateControls = void 0;
const graphql_1 = require("@app/gql-types/graphql");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const moment_1 = __importDefault(require("moment"));
const react_hook_form_1 = require("react-hook-form");
// TODO: create state to store period hour and minutes even when a day is undefined
// unite handle date change into single function
// implement handle period time change
const useUnavDateControls = (props) => {
    const { formControl, setValue, timePeriodInput, setTimePeriodInput } = props;
    const periodType = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'periodType' });
    const period = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'period' });
    const workMinutesInclusion = (0, react_hook_form_1.useWatch)({
        control: formControl,
        name: 'workMinutesInclusion',
    });
    const periodStartController = (0, react_hook_form_1.useController)({
        control: formControl,
        name: 'period.start',
        rules: {
            required: {
                value: true,
                message: (0, util_1.t)('FORM_ERR_MISSING_REQUIRED'),
            },
        },
    });
    const periodEndController = (0, react_hook_form_1.useController)({
        control: formControl,
        name: 'period.end',
        rules: {
            required: {
                value: true,
                message: (0, util_1.t)('FORM_ERR_MISSING_REQUIRED'),
            },
        },
    });
    const handleTimeChange = (p) => {
        const _start = p.start;
        const _end = p.end;
        const _startController = periodStartController.field.value;
        const _endController = periodEndController.field.value;
        const _startPeriod = (0, util_1.isDefined)(_startController)
            ? (0, moment_1.default)(_startController)
            : undefined;
        const _endPeriod = (0, util_1.isDefined)(_endController) ? (0, moment_1.default)(_endController) : undefined;
        setTimePeriodInput((prev) => ({
            start: (0, util_1.isDefined)(_start)
                ? (0, moment_1.default)().set({ hour: _start.hours, minute: _start.minutes })
                : prev.start,
            end: (0, util_1.isDefined)(_end)
                ? (0, moment_1.default)().set({ hour: _end.hours, minute: _end.minutes })
                : prev.end,
        }));
        if ((0, util_1.isDefined)(_start)) {
            periodStartController.field.onChange(_startPeriod
                ?.set({
                hour: _start.hours,
                minute: _start.minutes,
            })
                .startOf('minute'));
        }
        if ((0, util_1.isDefined)(_end)) {
            const _temp = (0, moment_1.default)(_endPeriod)
                .set({
                hour: _end.hours,
                minute: _end.minutes,
            })
                .startOf('minute');
            if (_temp.isBefore(periodStartController.field.value)) {
                _temp.add(1, 'days');
            }
            if (_temp.diff(periodStartController.field.value, 'minutes') >= 1440) {
                _temp.subtract(1, 'days');
            }
            periodEndController.field.onChange(_temp);
        }
    };
    const handleDateChange = (p) => {
        const newStart = (0, maybe_unwrap_1.unwrapMaybe)(p.start);
        const newEnd = (0, maybe_unwrap_1.unwrapMaybe)(p.end);
        // do the start
        const start = periodType === graphql_1.PeriodType.WholeDay
            ? newStart?.startOf('day')
            : newStart?.set({
                hour: timePeriodInput.start.get('hour'),
                minute: timePeriodInput.start.get('minute'),
                second: timePeriodInput.start.get('second'),
            });
        periodStartController.field.onChange(start);
        const isMultipleStart = moment_1.default.duration((0, moment_1.default)(period?.end).diff(start)).asDays() > 1;
        if (!isMultipleStart) {
            setValue('recurrence', null);
        }
        if (isMultipleStart && !(0, util_1.isValue)(workMinutesInclusion)) {
            setValue('workMinutesInclusion', graphql_1.TimeOffWorkMinutesInclusion.ShiftDays);
        }
        // do the end
        const end = periodType === graphql_1.PeriodType.WholeDay
            ? newEnd?.endOf('day')
            : newEnd?.set({
                hour: timePeriodInput.end.get('hour'),
                minute: timePeriodInput.end.get('minute'),
                second: timePeriodInput.end.get('second'),
            });
        periodEndController.field.onChange(end);
        const isMultipleEnd = moment_1.default.duration((0, moment_1.default)(end).diff(period?.start)).asDays() > 1;
        if (!isMultipleEnd) {
            setValue('recurrence', null);
        }
        if (isMultipleEnd && !(0, util_1.isValue)(workMinutesInclusion)) {
            setValue('workMinutesInclusion', graphql_1.TimeOffWorkMinutesInclusion.ShiftDays);
        }
    };
    return {
        periodStartController,
        periodEndController,
        handleDateChange,
        handleTimeChange,
    };
};
exports.useUnavDateControls = useUnavDateControls;
